import React from 'react';
import { getSkuFileArchiveData } from 'utils/apiRequests';

import { SkuFileArchiveContext } from '.';

export class SkuFileArchiveContextProvider extends React.Component {
	state = {
		fileArchive: null,
		isFetching: false,
	};

	componentDidMount() {
		this.fetchData();
	}

	fetchData = () => {
		this.setState({ isFetching: true });
		this.setState({ fileArchive: [] });
		this.setState({ isFetching: false });
		// getSkuFileArchiveData()
		// 	.then(fileArchive => {
		// 		const modifiedFileArchive = fileArchive.map(file => {
		// 			return {
		// 				date: file.timestamp,
		// 				userName: file.author,
		// 				downloadUrl: file.downloadUrl,
		// 				fileName: file.fileName,
		// 				status: file.status,
		// 			};
		// 		});
		// 		this.setState({ fileArchive: modifiedFileArchive });
		// 		this.setState({ isFetching: false });
		// 	})
		// 	.catch(() => {
		// 		this.setState({ fileArchive: [] });
		// 		this.setState({ isFetching: false });
		// 	});
	};

	render() {
		return (
			<SkuFileArchiveContext.Provider
				value={{
					...this.state,
					refetch: this.fetchData,
				}}
			>
				{this.state.fileArchive ? this.props.children : null}
			</SkuFileArchiveContext.Provider>
		);
	}
}
